import {pageInfo, initPage, saveData, editData,exportData, orderBasicDetailsInfo, selfPickupOrder} from './../api';
const assign = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    exportObj: null,
    orderBasicInfoObj: null
  },
  mutations: {

    PAGE_INFO(state,pageResp){
      state.total = pageResp.total;
      state.pageResp = (pageResp.obj || []).map((item, index) => {
        return {
          ...item,
          distributionDesc: item.carrierNo  ? '已分配' : '未分配'
          // btns: [true, true, true, true, true, item.isQiyeWxLoginStr == '已绑定'],//每行数据的操作按钮权限
        }
      });
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },

    async selfPickupOrder({ commit }, obj) {
      let resp = await selfPickupOrder(obj);
      commit('EDIT_DATA', resp);
    },

  }
}
export default assign



// WEBPACK FOOTER //
// ./src/page/order/assign/store/assign.store.js